import { render, staticRenderFns } from "./focus.vue?vue&type=template&id=a547f7a0&scoped=true"
import script from "./focus.vue?vue&type=script&lang=js"
export * from "./focus.vue?vue&type=script&lang=js"
import style0 from "./focus.vue?vue&type=style&index=0&id=a547f7a0&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a547f7a0",
  null
  
)

export default component.exports